








<div class="backgroundDialog" style="width: 100%; padding: 0px;margin: auto;">



    <div style="text-align: center; width: 15%;display: inline-block;  " >
      <mat-card style="border-radius: 0px 30px 30px 0px ; color: white;
                        background-color: rgb(46, 163, 80); font-size: 20px;">
          Resposta&nbsp;Contestação 
      </mat-card>
    </div>
    <div style="text-align: right; width: 78%; display: inline-block; " >
      <button  (click)="closeDialog()">
        <img src="../../assets/img/icones/fecharJanela.png" width="100%">
    </button>
    </div>
  
  
    <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center;">
      <div style="margin-top: 7px; ">Resposta para a contestação:</div>
    </div>
  


    



    <div style="width: 100%;">
      <table style="width: 99.8%; margin: auto;">
          <tr>
              <td style="width:100%">
                  <div>
                      
                          
                          <table style="text-align: left; width: 100%; height: 98%;">
                              
                              <tr style="cursor: pointer;">
                                <td style="width: 100%; height: 100%;" >
                                  <mat-card class="mat-elevation-z5" style="font-size: 12px; height: 100%;">


                                    <i style="font-weight: 800;">Última contestação / resposta cadastrada:</i>
                                   
                                        
                                          <table style="text-align: left; width: 95%; height: 98%; margin-top: 3px; margin: auto; ">
                                            <tr >
                                              <td style="width: 100%; height: 100%;" >
                                                <div  style="font-size: 12px; height: 100%;">                                
                                                  <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 2px;  margin-bottom: 3px;
                                                                  background-color:rgb(207, 121, 1);" class="mat-elevation-z4"> 
                                                    <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); background-color:rgb(252, 247, 242); padding: 5px; " class="mat-elevation-z4"> 
                                                      
                                                      <div id="divContainerContestacaoResposta" style="width: 100%;">
                                                        <div id="divAdjustAutoHeightContestacaoResposta" style="overflow-y: auto;">
                                                      
                                                          <table style="text-align: left; width: 95%; margin-top: 3px; margin: auto; ">
                                                            <tr >
                                                              <td style="width: 100%; height: 100%; font-weight: 500;" >
                                                                {{ultimaRespostaContestacao}}
                                                              </td>
                                                            </tr>
                                                          </table>

                                                        </div>
                                                      </div>

                                                    </mat-card>
                                                  </mat-card>
                                              </div>
                                            </td>
                                          </tr>
                                        </table>


                                      
                                    <br/>
                                    
                                    
                                    <i style="font-weight: 800;">Respondendo contestação acima:</i>


                                      <form  [formGroup]="formResponderContestacao" novalidate>
                                       
                                          <table style="text-align: left; width: 95%; height: 98%; margin-top: 3px; margin: auto; ">
                                            <tr >
                                              <td style="width: 100%; height: 100%;" >
                                                <div  style="font-size: 12px; height: 100%;">                                
                                                  <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 2px;  margin-bottom: 3px;
                                                                  background-color:rgb(207, 121, 1);" class="mat-elevation-z4"> 
                                                    <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); background-color:rgb(252, 247, 242); padding: 5px; " class="mat-elevation-z4"> 
                                                      
                                                      <table style="width: 100%; text-align: left; " >
                                                        <tr>
                                                          <td style="width: 100%;">

                                                            <div *ngIf="tipoUsuarioLogado == 4" style="width: 100%; text-align: center;">
                                                              <mat-radio-group formControlName="recoInProcedente">
                                                                
                                                                <mat-radio-button value="S" (checked)="true">
                                                                  <label style="margin-left: -27px; border-bottom: 2px solid grey; border-bottom-left-radius: 9px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                    Procedente &nbsp;
                                                                  </label>
                                                                  <label style="color: rgb(46, 163, 80); font-weight: bold; font-size: 14px; margin-top: 7px; margin-left: 0px; 
                                                                                  border: 2px solid grey; border-top-right-radius: 10px; ">
                                                                    &nbsp;
                                                                    &#10003; &nbsp;&nbsp;
                                                                  </label>
                                                                </mat-radio-button>
                                                                
                                                                &nbsp;&nbsp;&nbsp; 

                                                                <mat-radio-button value="N"> 
                                                                  <label style="margin-left: -27px; border-bottom: 2px solid grey; border-bottom-left-radius: 9px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                    Improcedente &nbsp;
                                                                  </label>
                                                                  <label style="color: rgb(248, 41, 110); font-weight: bold; font-size: 14px; margin-top: 7px; margin-left: 0px; 
                                                                                  border: 2px solid grey; border-top-right-radius: 10px; ">
                                                                    &nbsp;
                                                                    X&nbsp;&nbsp;
                                                                  </label>
                                                                </mat-radio-button>

                                                              </mat-radio-group>
                                                            </div>

                                                            
                                                            <div style="width: 95%; margin: 0 auto;">
                                                              <mat-form-field  appearance="outline">
                                                                <mat-label>
                                                                  <img src="../../assets/img/icones/setaDuplaDireita.png" width="16px">&nbsp;
                                                                  Descrição resposta
                                                                </mat-label>
                                                                <textarea rows="3" style="resize: none; white-space: pre-line;" formControlName="recoTxRespostaContestacao" matInput placeholder="Descrever resposta" ></textarea>
                                                              </mat-form-field>
                                                            </div>


                                                            <table style="width: 100%; text-align: left; margin-top: -10px;" >
                                                              <tr>
                                                                <td style="width: 50%; ">
                                                                  <input type="file" class="file-input" id="anexoRespostaMonitoria"
                                                                      [accept]="requiredFileType"
                                                                      (change)="onFileSelectedRespostaContestacao($event, fileUpload)" #fileUpload style="display: none;">

                                                                  <div class="file-upload" style="vertical-align: bottom;">
                                                                    
                                                                    <button *ngIf="!contemRespostaAnexo" mat-mini-fab style="background-color: rgb(207, 121, 1); width: 40px; height: 40px; " class="upload-btn"
                                                                      (click)="fileUpload.click()">
                                                                        <mat-icon style="width: 25px;"> attach_file</mat-icon>
                                                                    </button>

                                                                    <button *ngIf="contemRespostaAnexo" mat-mini-fab style="background-color: rgb(207, 121, 1);" class="upload-btn"
                                                                      (click)="downloadAnexoRespostaContestacao()">
                                                                        <mat-icon>cloud_download</mat-icon>
                                                                    </button>

                                                                    &nbsp;
                                                                    {{fileName || "Sem arquivo."}}


                                                                        <mat-icon  *ngIf="contemRespostaAnexo" style="color: rgb(248, 41, 110);  vertical-align: middle; cursor: pointer; font-weight: bold;"
                                                                            (click)="deletarRespostaAnexo()">
                                                                            close
                                                                        </mat-icon>

                                                                  </div>
                                                                </td>
                                                                <td style="width: 25%; ">
                                                                  <button mat-raised-button  type="button" (click)="salvarRespostaDaContestacao()"
                                                                    style="background-color: rgb(175, 156, 47); color: #fff; width: 100%; 
                                                                    font-size: 12px;">
                                                                    + Responder
                                                                  </button>
                                                                </td>
                                                                <td style="width: 25%; ">
                                                                  <button mat-raised-button  type="button" (click)="closeDialog()"
                                                                    style="background-color: red; color: #fff; width: 100%; 
                                                                    font-size: 12px;">
                                                                    cancelar
                                                                  </button>
                                                                  
                                                                </td>
                                                          
                                                              </tr>
                                                            </table>
                                                          </td>
                                                        </tr>
                                                      </table>
                                                    </mat-card>
                                                  </mat-card>
                                                </div>
                                              </td>                              
                                            </tr>
                                          </table>
                                      
                                        
                                      </form>


                                  </mat-card>
                                </td>                              
                            </tr>
  
                        </table>


                  </div>
              </td>
          </tr>
      </table>
      <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; text-align: center;">
        <div style="margin-top: 7px; margin-left: 15px; color: white;">Resposta Contestação </div>
      </div>
      
      
    </div>
  
  </div>